var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCentreHeroLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 187,
    viewBox: "0 0 284 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_184_805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.059,
    y: 52.749,
    width: 144.725,
    height: 118.524,
    rx: 8,
    transform: "rotate(2.70437 136.059 52.749)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.059,
    y: 52.749,
    width: 144.725,
    height: 118.524,
    rx: 8,
    transform: "rotate(2.70437 136.059 52.749)",
    stroke: "#222831"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.6 163.424L131.488 149.531",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.903 152.217C153.586 152.201 153.286 152.068 153.061 151.844C152.836 151.62 152.701 151.321 152.683 151.004L149.528 100.232C149.509 99.8922 149.627 99.5589 149.855 99.3055C150.082 99.0521 150.401 98.8996 150.741 98.8813C151.081 98.8631 151.415 98.9807 151.668 99.2082C151.921 99.4358 152.074 99.7546 152.092 100.095L155.219 150.861C155.236 151.201 155.119 151.534 154.892 151.787C154.665 152.041 154.347 152.194 154.007 152.214L153.903 152.217Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.495 153.737L145.455 151.893L145.271 155.785L184.311 157.629L184.495 153.737Z",
    fill: "#6F7379",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.229 139.697L166.133 138.937C165.496 138.906 164.859 139.003 164.26 139.222C163.66 139.441 163.111 139.777 162.643 140.212L159.589 143.038L188.337 144.396L185.563 141.294C185.14 140.821 184.628 140.436 184.056 140.162C183.484 139.888 182.863 139.73 182.229 139.697Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.395 154.139L139.7 151.838L154.652 142.455L193.775 144.303L188.395 154.139Z",
    fill: "#6F7379",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.843 153.782L147.253 152.195L160.46 142.729L187.967 144.029L180.843 153.782Z",
    fill: "#6F7379",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.699 151.851L147.285 152.209L147.133 155.423C147.115 155.813 146.942 156.179 146.653 156.442C146.365 156.704 145.984 156.842 145.594 156.823L140.948 156.604C140.558 156.585 140.191 156.413 139.929 156.124C139.666 155.836 139.529 155.454 139.547 155.065L139.699 151.851Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.809 153.792L188.394 154.15L188.242 157.364C188.224 157.754 188.051 158.121 187.763 158.383C187.474 158.646 187.093 158.783 186.703 158.765L182.057 158.545C181.667 158.527 181.301 158.354 181.038 158.066C180.776 157.777 180.638 157.396 180.657 157.006L180.809 153.792Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.235 157.527L193.365 149.541L193.776 144.303L188.396 154.138L188.235 157.527Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.627 153.146C193.944 153.16 194.255 153.056 194.5 152.854C194.745 152.652 194.907 152.367 194.955 152.053L202.962 102.777C203.012 102.44 202.926 102.097 202.724 101.823C202.521 101.55 202.218 101.368 201.881 101.317C201.544 101.267 201.201 101.353 200.928 101.556C200.654 101.758 200.472 102.061 200.422 102.398L192.415 151.674C192.389 151.842 192.397 152.013 192.438 152.178C192.479 152.343 192.552 152.498 192.653 152.634C192.754 152.77 192.881 152.885 193.027 152.972C193.172 153.059 193.334 153.116 193.502 153.14L193.627 153.146Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.934 90.2398L167.608 89.327C160.172 88.9757 156.705 94.0904 152.573 98.8773L200.997 101.165C197.339 96.0181 194.365 90.5909 186.934 90.2398Z",
    fill: "#FF4A01",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.051 101.97C204.508 101.986 203.275 101.231 202.458 100.508C202.117 100.037 201.78 99.5625 201.448 99.092C198.115 94.3822 194.665 89.5125 187.184 89.1591L167.466 88.2277C159.972 87.8737 156.091 92.3971 152.329 96.7718C151.953 97.2089 151.574 97.65 151.186 98.0865C150.321 98.7299 149.01 99.3648 148.471 99.2976C148.165 99.2444 147.85 99.3117 147.592 99.4854C147.334 99.659 147.153 99.9257 147.087 100.23C147.073 100.381 147.09 100.534 147.136 100.68C147.182 100.825 147.256 100.96 147.355 101.076C147.454 101.192 147.575 101.287 147.71 101.356C147.846 101.425 147.995 101.466 148.147 101.477L148.396 101.489C150.299 101.579 152.455 100.012 152.883 99.698C152.944 99.6508 153.001 99.5991 153.053 99.5433L154.289 98.1162C157.976 93.8298 161.163 90.1248 167.363 90.4177L187.08 91.349C193.279 91.6418 196.104 95.6308 199.37 100.246L200.466 101.783C200.513 101.843 200.564 101.9 200.62 101.953C201.02 102.318 203.024 104.069 204.918 104.159L205.168 104.171C205.32 104.174 205.472 104.147 205.614 104.091C205.755 104.035 205.885 103.952 205.994 103.846C206.103 103.739 206.19 103.612 206.249 103.472C206.309 103.332 206.34 103.181 206.34 103.028C206.303 102.72 206.149 102.437 205.908 102.24C205.668 102.043 205.361 101.946 205.051 101.97Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.824 97.9263L170.011 97.2266L171.127 86.4848L184.725 87.127L184.824 97.9263Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.724 96.5977L171.226 96.0074L172.027 87.6206L183.718 88.1729L183.724 96.5977Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.265 156.153C257.582 156.167 257.894 156.064 258.139 155.862C258.384 155.66 258.546 155.374 258.593 155.06L266.008 105.756C266.059 105.419 265.973 105.076 265.77 104.802C265.568 104.528 265.265 104.347 264.928 104.296C264.591 104.246 264.248 104.332 263.974 104.534C263.701 104.737 263.519 105.04 263.468 105.377L256.053 154.681C256.003 155.017 256.089 155.359 256.291 155.633C256.493 155.906 256.796 156.088 257.132 156.138L257.265 156.153Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.933 155.194C216.616 155.179 216.315 155.046 216.09 154.822C215.865 154.598 215.731 154.298 215.714 153.981L212.575 103.21C212.556 102.87 212.674 102.536 212.901 102.283C213.129 102.03 213.448 101.877 213.788 101.859C214.128 101.841 214.461 101.958 214.715 102.186C214.968 102.413 215.121 102.732 215.139 103.072L218.274 153.839C218.283 154.007 218.259 154.176 218.204 154.335C218.148 154.494 218.061 154.641 217.949 154.766C217.836 154.892 217.7 154.994 217.548 155.067C217.396 155.14 217.231 155.182 217.062 155.192L216.933 155.194Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.317 157.224L219.277 155.38L219.093 159.273L258.133 161.117L258.317 157.224Z",
    fill: "#6F7379",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.368 142.681L229.272 141.92C228.635 141.89 227.998 141.987 227.399 142.206C226.799 142.425 226.25 142.761 225.782 143.195L222.728 146.022L251.484 147.38L248.71 144.278C248.286 143.803 247.773 143.418 247.199 143.144C246.625 142.869 246.003 142.712 245.368 142.681Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.217 157.626L213.523 155.326L217.699 145.434L256.822 147.282L262.217 157.626Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.665 157.269L221.075 155.682L223.508 145.708L251.015 147.007L254.665 157.269Z",
    fill: "#6F7379",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.523 155.338L221.109 155.696L220.957 158.91C220.939 159.3 220.766 159.667 220.478 159.929C220.189 160.192 219.808 160.329 219.418 160.311L214.772 160.091C214.382 160.073 214.016 159.9 213.753 159.612C213.49 159.323 213.353 158.942 213.372 158.552L213.523 155.338Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.646 157.281L262.231 157.639L262.079 160.853C262.061 161.243 261.888 161.61 261.6 161.872C261.311 162.135 260.93 162.272 260.54 162.254L255.877 162.033C255.488 162.015 255.121 161.843 254.858 161.554C254.596 161.265 254.459 160.884 254.477 160.494L254.629 157.28L254.646 157.281Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.984 93.2191L230.658 92.3063C223.222 91.955 219.755 97.0697 215.628 101.857L264.052 104.144C260.389 98.9973 257.42 93.5704 249.984 93.2191Z",
    fill: "#FF4A01",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.098 104.949C267.554 104.965 266.322 104.21 265.509 103.487C265.164 103.016 264.827 102.541 264.495 102.07C261.162 97.3607 257.708 92.4908 250.214 92.1368L230.513 91.2062C223.019 90.8523 219.137 95.3757 215.376 99.7503C215 100.187 214.621 100.628 214.237 101.065C213.372 101.709 212.057 102.343 211.518 102.276C211.211 102.223 210.896 102.29 210.639 102.464C210.381 102.638 210.2 102.904 210.134 103.208C210.12 103.36 210.137 103.513 210.183 103.658C210.229 103.803 210.303 103.938 210.402 104.054C210.501 104.17 210.621 104.266 210.757 104.335C210.893 104.404 211.042 104.445 211.194 104.456L211.443 104.467C213.346 104.557 215.502 102.99 215.93 102.676C215.991 102.629 216.048 102.578 216.1 102.522L217.336 101.095C221.023 96.8083 224.21 93.1033 230.409 93.3962L250.11 94.3267C256.31 94.6196 259.134 98.6085 262.4 103.223L263.496 104.761C263.543 104.821 263.595 104.878 263.65 104.931C264.05 105.296 266.054 107.047 267.948 107.136L268.198 107.148C268.351 107.152 268.502 107.125 268.644 107.069C268.786 107.013 268.915 106.93 269.024 106.823C269.133 106.717 269.22 106.59 269.28 106.45C269.339 106.309 269.37 106.158 269.37 106.006C269.333 105.701 269.181 105.421 268.944 105.224C268.708 105.028 268.405 104.929 268.098 104.949Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.869 100.906L233.06 100.206L234.176 89.4643L247.77 90.1063L247.869 100.906Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.779 99.5764L234.277 98.9859L235.082 90.5994L246.768 91.1514L246.779 99.5764Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_184_805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 28.2119,
    width: 191.065,
    height: 156.476,
    rx: 8,
    transform: "rotate(-8.49105 3 28.2119)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 28.2119,
    width: 191.065,
    height: 156.476,
    rx: 8,
    transform: "rotate(-8.49105 3 28.2119)",
    stroke: "#222831"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip1_184_805)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.0362 118.368L62.3926 119.658L62.8364 122.631L71.48 121.34L71.0362 118.368Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.519 105.087L126.875 106.377L127.319 109.35L135.962 108.059L135.519 105.087Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.386 110.484L91.7422 111.774L92.186 114.747L100.83 113.457L100.386 110.484Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.6436 115.969L55 117.26L55.4438 120.232L64.0874 118.942L63.6436 115.969Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.017 101.13L153.373 102.421L153.817 105.394L162.46 104.103L162.017 101.13Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.759 86.9254L131.115 88.2158L131.559 91.1885L140.203 89.8981L139.759 86.9254Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.204 95.3883L99.5605 96.6787L100.004 99.6514L108.648 98.361L108.204 95.3883Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.3565 101.158L65.7129 102.448L66.1567 105.421L74.8003 104.13L74.3565 101.158Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.0265 99.7145L75.3828 101.005L75.8266 103.978L84.4703 102.687L84.0265 99.7145Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.112 93.7604L110.469 95.0508L110.913 98.0235L119.556 96.733L119.112 93.7604Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.2511 106.787L50.6074 108.077L51.0512 111.05L59.6949 109.759L59.2511 106.787Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M157.235 106.046L148.592 107.337L149.036 110.31L157.679 109.019L157.235 106.046Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M167.112 104.572L158.469 105.862L158.913 108.835L167.556 107.545L167.112 104.572Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.2628 116.913L80.6191 118.203L81.0629 121.176L89.7066 119.885L89.2628 116.913Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.4776 121.829L75.834 123.119L76.2778 126.092L84.9214 124.801L84.4776 121.829Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M94.3585 120.354L85.7148 121.645L86.1586 124.617L94.8023 123.327L94.3585 120.354Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.1769 123.196L38.5332 124.486L38.977 127.459L47.6206 126.169L47.1769 123.196Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.3917 128.112L33.748 129.402L34.1918 132.375L42.8355 131.085L42.3917 128.112Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.2706 126.637L43.627 127.928L44.0707 130.9L52.7144 129.61L52.2706 126.637Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.273 109.148L132.629 110.438L133.073 113.411L141.716 112.121L141.273 109.148Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M136.487 114.064L127.844 115.354L128.288 118.327L136.931 117.037L136.487 114.064Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M146.368 112.589L137.725 113.88L138.168 116.853L146.812 115.562L146.368 112.589Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.0772 105.078L71.4336 106.368L71.8774 109.341L80.521 108.05L80.0772 105.078Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.2921 109.994L66.6484 111.284L67.0922 114.257L75.7359 112.966L75.2921 109.994Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M85.169 108.519L76.5254 109.81L76.9692 112.782L85.6128 111.492L85.169 108.519Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.9425 96.3024L71.2988 97.5928L71.7426 100.565L80.3863 99.275L79.9425 96.3024Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.2726 95.2731L56.6289 96.5635L57.0727 99.5361L65.7163 98.2457L65.2726 95.2731Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.775 84.2838L113.131 85.5742L113.575 88.5469L122.218 87.2565L121.775 84.2838Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.884 85.3541L142.24 86.6445L142.684 89.6172L151.328 88.3268L150.884 85.3541Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M145.88 91.2828L137.236 92.5732L137.68 95.5459L146.324 94.2555L145.88 91.2828Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.454 64.3902L94.8105 65.6807L95.2543 68.6533L103.898 67.3629L103.454 64.3902Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M90.919 72.4899L82.2754 73.7803L82.7192 76.7529L91.3628 75.4625L90.919 72.4899Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M109.575 68.7516L100.932 70.042L101.375 73.0147L110.019 71.7242L109.575 68.7516Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M113.021 91.0065L104.377 92.2969L104.821 95.2695L113.464 93.9791L113.021 91.0065Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.786 81.6578L98.1426 82.9482L98.5864 85.9209L107.23 84.6305L106.786 81.6578Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.9093 83.1324L88.2656 84.4229L88.7094 87.3955L97.3531 86.1051L96.9093 83.1324Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.353 78.8941L92.709 80.1846L93.1528 83.1572L101.796 81.8668L101.353 78.8941Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.296 67.6764L77.6523 68.9668L78.0961 71.9395L86.7398 70.649L86.296 67.6764Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.357 60.8561L115.713 62.1465L116.157 65.1192L124.8 63.8287L124.357 60.8561Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.48 62.3307L105.836 63.6211L106.28 66.5938L114.923 65.3033L114.48 62.3307Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.923 58.0914L110.279 59.3818L110.723 62.3545L119.367 61.0641L118.923 58.0914Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.9796 58.4088L85.3359 59.6992L85.7797 62.6719L94.4234 61.3815L93.9796 58.4088Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M98.6944 88.0514L90.0508 89.3418L90.4946 92.3145L99.1382 91.024L98.6944 88.0514Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.468 70.2428L151.824 71.5332L152.268 74.5059L160.912 73.2155L160.468 70.2428Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.587 71.7184L141.943 73.0088L142.387 75.9815L151.031 74.691L150.587 71.7184Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.032 67.4791L146.389 68.7695L146.832 71.7422L155.476 70.4518L155.032 67.4791Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.374 76.6334L143.73 77.9238L144.174 80.8965L152.818 79.6061L152.374 76.6334Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M174.046 75.816L165.402 77.1064L165.846 80.0791L174.49 78.7887L174.046 75.816Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.173 74.2447L176.529 75.5352L176.973 78.5078L185.617 77.2174L185.173 74.2447Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.165 80.1744L171.521 81.4648L171.965 84.4375L180.609 83.1471L180.165 80.1744Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.665 56.4791L143.021 57.7695L143.465 60.7422L152.109 59.4518L151.665 56.4791Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.786 57.9547L133.143 59.2451L133.586 62.2178L142.23 60.9274L141.786 57.9547Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M146.232 53.7154L137.588 55.0059L138.032 57.9785L146.675 56.6881L146.232 53.7154Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.573 62.8727L134.93 64.1631L135.373 67.1358L144.017 65.8453L143.573 62.8727Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.8995 69.8805L53.2559 71.1709L53.6997 74.1436L62.3433 72.8531L61.8995 69.8805Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.0186 71.3561L43.375 72.6465L43.8188 75.6192L52.4624 74.3287L52.0186 71.3561Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.4659 67.1168L47.8223 68.4072L48.2661 71.3799L56.9097 70.0895L56.4659 67.1168Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.8058 76.274L45.1621 77.5645L45.6059 80.5371L54.2496 79.2467L53.8058 76.274Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.007 71.9274L124.363 73.2178L124.807 76.1904L133.451 74.9L133.007 71.9274Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M137.816 75.9479L129.172 77.2383L129.616 80.211L138.259 78.9205L137.816 75.9479Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M171.443 134.129L210.623 128.28",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3379 156.538L170.203 134.314",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3402 151.454C75.314 150.114 81.5026 141.754 80.1629 132.78C78.8232 123.806 70.4625 117.617 61.4887 118.957C52.5149 120.297 46.3263 128.657 47.666 137.631C49.0057 146.605 57.3664 152.794 66.3402 151.454Z",
    fill: "#FF4A01",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2148 126.031L52.9638 145.284",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M70.771 121.228L68.0382 124.92",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4188 147.403L56.4199 148.755",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0389 134.409L58.1199 146.459",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M74.922 123.757L67.7773 133.409",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9267 121.484C67.0663 122.419 66.183 123.324 64.9577 123.507C63.7324 123.69 62.6206 123.082 62.481 122.147C62.3415 121.213 63.2247 120.307 64.4527 120.124C65.6806 119.941 66.7863 120.544 66.9267 121.484Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1346 116.832C35.1346 116.832 32.0399 115.674 32.3647 119.291C32.6895 122.907 35.6517 146.379 35.6517 146.379",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9355 119.839C30.9355 119.839 34.0401 124.674 36.139 145.993",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9785 117.894C32.9785 117.894 31.991 118.758 31.2507 118.049C30.5103 117.34 31.3327 115.716 30.3203 115.228C29.3079 114.739 27.8631 115.932 27.8631 115.932C27.8631 115.932 29.139 116.106 29.1989 116.781C29.2587 117.456 28.7234 117.791 28.5864 117.512C28.4495 117.233 27.6634 115.853 26.7636 116.611C26.5024 116.822 26.287 117.084 26.1305 117.382C25.974 117.679 25.8798 118.005 25.8535 118.34C25.8535 118.34 28.1232 117.748 28.3941 118.595C28.6649 119.442 27.4231 118.585 26.4638 118.671C25.5045 118.757 24.6546 119.028 24.8018 119.594C24.8995 120.101 24.9453 120.616 24.9387 121.131C25.3969 120.619 26.0238 120.287 26.7054 120.198C27.7618 120.105 27.8212 120.777 26.862 120.863C25.9027 120.949 25.2115 121.992 25.2115 121.992C25.2115 121.992 26.3017 123.349 27.5138 123.916C28.726 124.484 29.0865 124.164 29.1301 123.58C29.1736 122.996 28.6613 121.588 29.3354 121.526C30.0096 121.463 28.6058 124.208 29.4667 124.229C30.3276 124.251 30.9863 123.902 31.1261 123.306L31.2664 122.714C31.2664 122.714 30.754 121.306 30.7975 120.722C30.8411 120.138 31.0876 120.695 31.3381 121.352C31.5887 122.009 31.9302 123.622 32.2037 123.502C32.4772 123.382 33.2375 122.054 33.3863 121.556C33.5351 121.057 31.8764 119.85 31.8525 119.563C31.8286 119.275 33.0243 119.66 33.2404 119.922C33.3991 120.127 33.5472 120.34 33.6844 120.561C33.6844 120.561 34.3144 120.02 34.0983 118.683C33.8823 117.345 32.9785 117.894 32.9785 117.894Z",
    fill: "#FF4A01"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.9785 117.894C32.9785 117.894 31.991 118.758 31.2507 118.049C30.5103 117.34 31.3327 115.716 30.3203 115.228C29.3079 114.739 27.8631 115.932 27.8631 115.932C27.8631 115.932 29.139 116.106 29.1989 116.781C29.2587 117.456 28.7234 117.791 28.5864 117.512C28.4495 117.233 27.6634 115.853 26.7636 116.611C26.5024 116.822 26.287 117.084 26.1305 117.382C25.974 117.679 25.8798 118.005 25.8535 118.34C25.8535 118.34 28.1232 117.748 28.3941 118.595C28.6649 119.442 27.4231 118.585 26.4638 118.671C25.5045 118.757 24.6546 119.028 24.8018 119.594C24.8995 120.101 24.9453 120.616 24.9387 121.131C25.3969 120.619 26.0238 120.287 26.7054 120.198C27.7618 120.105 27.8212 120.777 26.862 120.863C25.9027 120.949 25.2115 121.992 25.2115 121.992C25.2115 121.992 26.3017 123.349 27.5138 123.916C28.726 124.484 29.0865 124.164 29.1301 123.58C29.1736 122.996 28.6613 121.588 29.3354 121.526C30.0096 121.463 28.6058 124.208 29.4667 124.229C30.3276 124.251 30.9863 123.902 31.1261 123.306L31.2664 122.714C31.2664 122.714 30.754 121.306 30.7975 120.722C30.8411 120.138 31.0876 120.695 31.3381 121.352C31.5887 122.009 31.9302 123.622 32.2037 123.502C32.4772 123.382 33.2375 122.054 33.3863 121.556C33.5351 121.057 31.8764 119.85 31.8525 119.563C31.8286 119.275 33.0243 119.66 33.2404 119.922C33.3991 120.127 33.5472 120.34 33.6844 120.561C33.6844 120.561 34.3144 120.02 34.0983 118.683C33.8823 117.345 32.9785 117.894 32.9785 117.894Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9101 121.861C28.4897 120.873 29.3614 119.526 30.158 118.824",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2431 123.05C27.2431 123.05 27.3864 122.77 27.6279 122.344",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6523 118.975C30.6523 118.975 31.9413 120.313 32.3603 121.824",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5866 120.04C29.5866 120.04 29.8587 119.82 30.0311 121.741",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M30.096 118.153C30.096 118.153 30.6211 117.53 30.1424 116.512",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 119.183L28.8672 118.456",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6261 120.121C28.6261 120.121 27.097 119.29 26.2344 119.367",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4494 114.49C36.4494 114.49 36.6414 116.068 35.4277 116.328C34.2139 116.588 33.1467 114.656 31.9657 115.336C30.7846 116.016 30.9992 118.274 30.9992 118.274C30.9992 118.274 32.0439 117.119 32.7568 117.516C33.4696 117.914 33.4369 118.698 33.0754 118.629C32.7139 118.56 30.7823 118.427 30.928 119.84C30.9622 120.245 31.0781 120.639 31.2689 120.998C31.4596 121.357 31.7211 121.674 32.0377 121.929C32.0377 121.929 32.9997 119.253 34.0258 119.56C35.052 119.867 33.3528 120.524 32.7864 121.545C32.2199 122.566 31.9111 123.598 32.5837 123.835C33.1576 124.083 33.705 124.388 34.2173 124.746C34.0169 123.942 34.1103 123.093 34.4807 122.351C35.1081 121.228 35.8214 121.628 35.2519 122.647C34.6824 123.666 35.2518 125.054 35.2518 125.054C35.2518 125.054 37.3533 124.885 38.7493 124.059C40.1454 123.232 40.0675 122.655 39.5109 122.21C38.9543 121.765 37.1998 121.322 37.5971 120.609C37.9945 119.896 39.7839 123.163 40.3963 122.304C41.0086 121.445 41.1033 120.565 40.5985 120.011L40.1007 119.467C40.1007 119.467 38.3432 119.022 37.7896 118.579C37.2361 118.136 37.9603 118.281 38.7884 118.465C39.6164 118.649 41.4644 119.427 41.5348 119.06C41.6053 118.693 40.7866 117.039 40.3893 116.549C39.992 116.058 37.6556 116.897 37.3502 116.73C37.0449 116.563 38.2357 115.62 38.6552 115.585C38.9693 115.566 39.2841 115.562 39.5986 115.575C39.5986 115.575 39.4849 114.576 38.0008 113.883C36.5167 113.189 36.4494 114.49 36.4494 114.49Z",
    fill: "#FF4A01"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.4494 114.49C36.4494 114.49 36.6414 116.068 35.4277 116.328C34.2139 116.588 33.1467 114.656 31.9657 115.336C30.7846 116.016 30.9992 118.274 30.9992 118.274C30.9992 118.274 32.0439 117.119 32.7568 117.516C33.4696 117.914 33.4369 118.698 33.0754 118.629C32.7139 118.56 30.7823 118.427 30.928 119.84C30.9622 120.245 31.0781 120.639 31.2689 120.998C31.4596 121.357 31.7211 121.674 32.0377 121.929C32.0377 121.929 32.9997 119.253 34.0258 119.56C35.052 119.867 33.3528 120.524 32.7864 121.545C32.2199 122.566 31.9111 123.598 32.5837 123.835C33.1576 124.083 33.705 124.388 34.2173 124.746C34.0169 123.942 34.1103 123.093 34.4807 122.351C35.1081 121.228 35.8214 121.628 35.2519 122.647C34.6824 123.666 35.2518 125.054 35.2518 125.054C35.2518 125.054 37.3533 124.885 38.7493 124.059C40.1454 123.232 40.0675 122.655 39.5109 122.21C38.9543 121.765 37.1998 121.322 37.5971 120.609C37.9945 119.896 39.7839 123.163 40.3963 122.304C41.0086 121.445 41.1033 120.565 40.5985 120.011L40.1007 119.467C40.1007 119.467 38.3432 119.022 37.7896 118.579C37.2361 118.136 37.9603 118.281 38.7884 118.465C39.6164 118.649 41.4644 119.427 41.5348 119.06C41.6053 118.693 40.7866 117.039 40.3893 116.549C39.992 116.058 37.6556 116.897 37.3502 116.73C37.0449 116.563 38.2357 115.62 38.6552 115.585C38.9693 115.566 39.2841 115.562 39.5986 115.575C39.5986 115.575 39.4849 114.576 38.0008 113.883C36.5167 113.189 36.4494 114.49 36.4494 114.49Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9684 122.272C36.3754 121.018 35.6203 119.224 35.4603 117.952",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7117 123.753C37.7117 123.753 37.5279 123.415 37.2637 122.886",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9473 117.555C35.9473 117.555 38.1629 117.183 39.9656 117.786",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2878 119.347C36.2878 119.347 36.2551 118.927 38.3011 120.065",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7458 117.551C34.7458 117.551 34.4728 116.598 33.125 116.38",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M35.309 118.938L34.209 118.993",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7171 120.369C35.7171 120.369 33.8454 121.33 33.3317 122.248",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8496 126.912C24.8496 126.912 31.7066 130.106 33.9769 146.098",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3823 124.673C32.3823 124.673 32.4526 126.512 31.0262 126.698C29.5998 126.883 28.5548 124.553 27.1273 125.224C25.6998 125.894 25.7327 128.523 25.7327 128.523C25.7327 128.523 27.0489 127.289 27.8353 127.814C28.6217 128.339 28.5086 129.241 28.0954 129.137C27.6823 129.032 25.4705 128.682 25.5057 130.34C25.5068 130.811 25.6034 131.276 25.7897 131.709C25.9759 132.141 26.2479 132.531 26.5892 132.855C26.5892 132.855 27.9468 129.856 29.1079 130.301C30.269 130.746 28.2408 131.351 27.4884 132.476C26.736 133.601 26.2828 134.761 27.0334 135.101C27.6731 135.439 28.2763 135.843 28.8334 136.305C28.8334 136.305 28.5356 134.803 29.3638 133.566C30.1921 132.328 30.9762 132.856 30.2238 133.982C29.4714 135.107 29.9957 136.758 29.9957 136.758C29.9957 136.758 32.4467 136.76 34.1216 135.94C35.7965 135.121 35.777 134.443 35.1751 133.877C34.5731 133.311 32.5871 132.63 33.1154 131.845C33.6437 131.061 35.3973 135.001 36.1864 134.066C36.9754 133.132 37.167 132.117 36.644 131.441L36.1183 130.765C36.1183 130.765 34.1323 130.084 33.533 129.518C32.9338 128.951 33.7553 129.182 34.696 129.483C35.6368 129.783 37.6953 130.84 37.8081 130.429C37.9209 130.017 37.1359 128.024 36.725 127.424C36.314 126.823 33.537 127.556 33.2016 127.334C32.8662 127.112 34.3295 126.134 34.8174 126.137C35.1853 126.143 35.5526 126.168 35.9179 126.212C35.9179 126.212 35.8827 125.047 34.2416 124.105C32.6006 123.162 32.3823 124.673 32.3823 124.673Z",
    fill: "#FF4A01"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.3823 124.673C32.3823 124.673 32.4526 126.512 31.0262 126.698C29.5998 126.883 28.5548 124.553 27.1273 125.224C25.6998 125.894 25.7327 128.523 25.7327 128.523C25.7327 128.523 27.0489 127.289 27.8353 127.814C28.6217 128.339 28.5086 129.241 28.0954 129.137C27.6823 129.032 25.4705 128.682 25.5057 130.34C25.5068 130.811 25.6034 131.276 25.7897 131.709C25.9759 132.141 26.2479 132.531 26.5892 132.855C26.5892 132.855 27.9468 129.856 29.1079 130.301C30.269 130.746 28.2408 131.351 27.4884 132.476C26.736 133.601 26.2828 134.761 27.0334 135.101C27.6731 135.439 28.2763 135.843 28.8334 136.305C28.8334 136.305 28.5356 134.803 29.3638 133.566C30.1921 132.328 30.9762 132.856 30.2238 133.982C29.4714 135.107 29.9957 136.758 29.9957 136.758C29.9957 136.758 32.4467 136.76 34.1216 135.94C35.7965 135.121 35.777 134.443 35.1751 133.877C34.5731 133.311 32.5871 132.63 33.1154 131.845C33.6437 131.061 35.3973 135.001 36.1864 134.066C36.9754 133.132 37.167 132.117 36.644 131.441L36.1183 130.765C36.1183 130.765 34.1323 130.084 33.533 129.518C32.9338 128.951 33.7553 129.182 34.696 129.483C35.6368 129.783 37.6953 130.84 37.8081 130.429C37.9209 130.017 37.1359 128.024 36.725 127.424C36.314 126.823 33.537 127.556 33.2016 127.334C32.8662 127.112 34.3295 126.134 34.8174 126.137C35.1853 126.143 35.5526 126.168 35.9179 126.212C35.9179 126.212 35.8827 125.047 34.2416 124.105C32.6006 123.162 32.3823 124.673 32.3823 124.673Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M32.244 133.7C31.689 132.19 30.9759 130.058 30.9121 128.573",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9614 135.48C32.9614 135.48 32.781 135.074 32.5332 134.436",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5137 128.161C31.5137 128.161 34.1031 127.941 36.1276 128.807",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M31.737 130.277C31.737 130.277 31.7377 129.789 33.9869 131.302",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1276 128.044C30.1276 128.044 29.9053 126.92 28.3672 126.54",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6462 129.698L29.3711 129.657",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9819 131.386C30.9819 131.386 28.7276 132.319 28.0484 133.332",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1623 139.138C29.1623 139.138 33.6399 141.606 34.7427 146.093L31.6214 130.986",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5646 135.463C33.1325 135.302 34.7435 146.092 34.7435 146.092",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M35.367 145.89C35.367 145.89 28.9687 124.026 37.8547 122.699",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4517 135.122C35.6086 134.417 34.0743 134.646 33.4815 136.859C32.8887 139.071 33.647 138.587 33.647 138.587C33.647 138.587 35.2829 137.799 36.3117 137.267C37.3406 136.734 38.6507 135.624 38.8224 136.154C38.994 136.684 38.2624 137.346 37.2958 137.675C36.3293 138.005 33.8134 139.118 34.1605 139.619C34.5076 140.12 35.3871 141.653 35.3871 141.653C36.0644 140.881 36.7921 140.156 37.5655 139.481C38.632 138.581 39.3944 138.745 38.8817 139.652C38.3691 140.559 36.7009 141.734 37.2251 142.764C37.7492 143.794 40.1106 144.82 40.1106 144.82C40.1106 144.82 40.0398 142.521 40.5686 141.704C41.0975 140.887 41.2134 141.7 41.2239 142.992C41.2135 143.544 41.234 144.095 41.2853 144.644L43.948 145.17C44.2669 144.478 44.6297 143.807 45.0342 143.161L45.4167 142.641C45.4167 142.641 43.1735 141.223 42.9211 140.152C42.6687 139.081 44.2769 139.95 44.7568 140.063C45.2366 140.177 46.1447 141.335 46.1447 141.335C46.1447 141.335 46.2874 139.189 46.2591 138.453L46.2419 137.717C46.2419 137.717 44.2376 137.279 43.5131 137.387C42.7886 137.495 42.5112 138.081 42.4046 137.367C42.298 136.653 42.9511 136.085 43.777 136.054C44.5306 136.064 45.2823 136.134 46.0248 136.263C46.0248 136.263 46.4899 135.731 46.1148 134.403C45.7396 133.076 45.2811 133.142 44.251 133.666C43.221 134.19 42.62 135.108 41.8076 135.229C40.9952 135.35 41.297 134.289 41.8003 133.939C42.3035 133.589 43.5775 132.857 43.831 132.713C44.0845 132.569 42.1849 131.573 41.2549 131.526C40.3248 131.48 39.2505 132.291 39.4702 133.179C39.9528 135.062 37.2975 135.826 36.4517 135.122Z",
    fill: "#FF4A01"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6543 143.553C43.7207 143.815 43.7791 144.079 43.8323 144.362",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M40.875 137.354C41.9339 139.024 42.785 140.817 43.4095 142.694",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4398 136.664C39.8487 135.769 39.4096 135.236 39.4096 135.236C39.8674 134.928 40.2207 134.489 40.4225 133.976C40.5702 133.517 40.8241 133.1 41.1636 132.757",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7239 138.79C36.7239 138.79 39.7711 136.949 39.8117 137.221",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5218 136.304C41.5218 136.304 42.8604 135.366 44.1257 135.177",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3049 138.553C40.7555 139.161 40.2667 139.821 39.8456 140.525C39.4107 141.226 39.0885 141.99 38.8905 142.791",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3517 138.767C42.3517 138.767 44.1687 137.951 45.2955 138.695",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9648 126.049C42.8952 125.615 41.8038 125.765 41.1796 125.232C40.5554 124.699 41.5557 124.231 42.1416 124.38C42.7276 124.529 44.1402 124.999 44.4018 125.11C44.6634 125.221 44.1809 123.12 43.6058 122.386C43.0306 121.652 41.7148 121.375 41.1889 122.121C40.0817 123.696 37.7606 122.194 37.7408 121.094C37.7209 119.994 36.541 118.986 34.4822 119.988C32.4233 120.989 33.2854 121.255 33.2854 121.255C33.2854 121.255 34.9601 121.967 36.0301 122.403C37.1001 122.84 38.8022 123.079 38.5158 123.568C38.2294 124.057 37.2486 123.926 36.3686 123.412C35.4885 122.898 32.9979 121.737 32.8488 122.325C32.6998 122.914 32.1188 124.586 32.1188 124.586C33.1425 124.59 34.1648 124.662 35.1791 124.801C36.5566 125.018 36.9334 125.699 35.9135 125.909C34.8937 126.118 32.9138 125.624 32.4905 126.692C32.0672 127.76 32.8304 130.228 32.8304 130.228C32.8304 130.228 34.5232 128.671 35.4856 128.532C36.4479 128.394 35.9114 129.013 34.9417 129.869C34.5183 130.224 34.1147 130.601 33.7327 131L35.0836 133.355C35.8149 133.143 36.5586 132.978 37.3106 132.859L37.954 132.809C37.954 132.809 37.5619 130.183 38.1996 129.293C38.8373 128.402 39.2393 130.183 39.4675 130.617C39.6957 131.052 39.4219 132.5 39.4219 132.5C39.4219 132.5 41.1337 131.199 41.6779 130.704L42.2222 130.209C42.2222 130.209 41.2399 128.409 40.6843 127.933C40.1286 127.458 39.4963 127.637 39.9689 127.082C40.4416 126.526 41.2967 126.655 41.8604 127.257C42.3453 127.835 42.7833 128.45 43.17 129.098C43.17 129.098 43.885 129.108 44.6322 127.948C45.3795 126.789 45.0348 126.486 43.9648 126.049ZM35.8473 130.208C35.0713 129.953 36.679 128.975 36.679 128.975C37.2984 128.801 36.6244 130.47 35.8473 130.208ZM36.5611 126.654C36.2291 126.545 37.1073 126.098 37.1073 126.098C38.4819 126.168 36.8937 126.784 36.5627 126.664L36.5611 126.654Z",
    fill: "#FF4A01"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1061 132.059C35.9468 132.287 35.7836 132.507 35.6117 132.724",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9725 125.885C38.4066 127.782 37.6101 129.602 36.601 131.304",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1995 125.116C39.4863 124.082 39.6162 123.42 39.6162 123.42C40.1512 123.567 40.7186 123.545 41.2407 123.357C41.6835 123.168 42.1648 123.085 42.6454 123.117",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M35.168 123.691C35.168 123.691 38.5556 124.787 38.3798 124.996",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1816 125.696C40.1816 125.696 41.7682 126.091 42.739 126.921",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3408 127.006C37.521 126.989 36.7015 127.053 35.8941 127.197C35.08 127.328 34.2916 127.586 33.5576 127.962",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8672 127.938C38.8672 127.938 40.6777 128.756 40.8478 130.114",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7997 140.661C30.9306 140.311 30.0606 140.43 29.5578 139.999C29.055 139.567 29.8598 139.194 30.3378 139.313C30.8158 139.432 31.9429 139.814 32.1575 139.902C32.3721 139.99 31.9802 138.295 31.5172 137.71C31.0541 137.126 29.9957 136.894 29.579 137.496C28.6794 138.766 26.821 137.554 26.8063 136.671C26.7916 135.788 25.8415 134.969 24.1737 135.781C22.506 136.594 23.2112 136.794 23.2112 136.794C23.2112 136.794 24.5574 137.366 25.4185 137.717C26.2796 138.067 27.6524 138.271 27.421 138.654C27.1895 139.037 26.402 138.942 25.6921 138.528C24.9822 138.114 22.9797 137.177 22.8605 137.655C22.7412 138.133 22.2712 139.472 22.2712 139.472C23.0998 139.475 23.9272 139.534 24.7481 139.647C25.8633 139.821 26.1577 140.37 25.3388 140.539C24.5198 140.707 22.9107 140.308 22.5612 141.177C22.2117 142.046 22.8362 144.022 22.8362 144.022C22.8362 144.022 24.1983 142.768 24.9712 142.655C25.7441 142.542 25.302 143.047 24.5331 143.733C24.1931 144.019 23.8684 144.322 23.5603 144.641L24.6601 146.535C25.2494 146.365 25.8489 146.232 26.455 146.137L26.9716 146.095C26.9716 146.095 26.6562 143.983 27.1701 143.266C27.684 142.55 28.0068 143.983 28.19 144.334C28.3731 144.685 28.1439 145.849 28.1439 145.849C28.1439 145.849 29.5207 144.802 29.9596 144.405L30.3982 144.004C30.3982 144.004 29.6075 142.556 29.1609 142.174C28.7144 141.791 28.2049 141.935 28.5849 141.489C28.9649 141.043 29.6527 141.145 30.109 141.629C30.4928 142.094 30.8397 142.589 31.1467 143.108C31.1467 143.108 31.7222 143.115 32.3265 142.183C32.9308 141.252 32.6604 141.009 31.7997 140.661ZM25.2692 144.013C24.6425 143.81 25.9379 143.02 25.9379 143.02C26.4359 142.872 25.8937 144.219 25.2692 144.013ZM25.8416 141.153C25.5756 141.067 26.2817 140.708 26.2817 140.708C27.3858 140.753 26.108 141.241 25.8416 141.153Z",
    fill: "#FF4A01"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M25.474 145.497C25.346 145.679 25.2146 145.857 25.077 146.03",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7819 140.528C27.3266 142.057 26.6851 143.525 25.8719 144.898",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9628 139.908C28.1926 139.076 28.3023 138.534 28.3023 138.534C28.7294 138.651 29.1823 138.634 29.5992 138.484C29.957 138.332 30.3456 138.267 30.7335 138.293",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7188 138.761C24.7188 138.761 27.4457 139.644 27.3017 139.81",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7539 140.375C28.7539 140.375 30.0296 140.694 30.8074 141.362",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2715 141.429C26.6122 141.417 25.9534 141.469 25.304 141.584C24.6492 141.69 24.015 141.897 23.4244 142.199",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6973 142.178C27.6973 142.178 29.1587 142.847 29.2932 143.93",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3474 126.226C26.3474 126.226 25.462 127.099 24.7199 126.469C23.9778 125.839 24.6629 124.264 23.6842 123.854C22.7054 123.445 21.4024 124.658 21.4024 124.658C21.4024 124.658 22.6168 124.749 22.7119 125.386C22.8069 126.022 22.314 126.368 22.1748 126.111C22.0357 125.854 21.2077 124.594 20.399 125.361C20.1643 125.575 19.9755 125.835 19.8442 126.125C19.7129 126.415 19.6417 126.728 19.6349 127.046C19.6349 127.046 21.7491 126.36 22.0515 127.145C22.3539 127.931 21.135 127.189 20.232 127.324C19.329 127.459 18.5436 127.762 18.7149 128.289C18.8344 128.763 18.9068 129.247 18.9308 129.735C19.3328 129.228 19.903 128.881 20.5385 128.757C21.532 128.609 21.6263 129.24 20.7233 129.375C19.8203 129.51 19.229 130.51 19.229 130.51C19.229 130.51 20.3344 131.731 21.5128 132.201C22.6911 132.67 23.0132 132.347 23.0227 131.79C23.0321 131.233 22.4732 129.933 23.0991 129.84C23.7251 129.746 22.5604 132.415 23.3863 132.384C24.2123 132.353 24.8057 131.987 24.9057 131.416L25.0073 130.857C25.0073 130.857 24.4426 129.555 24.4578 129C24.4729 128.445 24.7241 128.96 25.0022 129.564C25.2802 130.168 25.6881 131.678 25.9463 131.547C26.2045 131.416 26.8415 130.12 26.9528 129.643C27.0641 129.166 25.4341 128.116 25.3936 127.844C25.353 127.573 26.5047 127.864 26.7234 128.106C26.8856 128.291 27.0381 128.485 27.1803 128.686C27.1803 128.686 27.7439 128.139 27.4569 126.891C27.1699 125.643 26.3474 126.226 26.3474 126.226Z",
    fill: "#FF4A01"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7753 130.258C22.2686 129.294 23.0186 127.97 23.7302 127.264",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M21.213 131.426C21.213 131.426 21.3354 131.151 21.5373 130.734",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2109 127.378C24.2109 127.378 25.4971 128.569 25.982 129.975",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2625 128.443C23.2625 128.443 23.5018 128.222 23.7714 130.028",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6353 126.631C23.6353 126.631 24.0885 126.019 23.5874 125.07",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0489 127.642L22.4883 126.987",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3577 128.578C22.3577 128.578 20.8671 127.878 20.0547 127.999",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9493 155.156L39.9893 155.15L38.5088 145.234C38.4607 144.911 36.8501 144.885 34.9136 145.174C32.9771 145.463 31.448 145.964 31.4953 146.281C31.5009 146.318 31.5591 146.489 31.567 146.542L33.0074 156.19L33.0473 156.184C33.028 156.219 33.0198 156.259 33.0237 156.299C33.0849 156.709 34.6978 156.806 36.6236 156.519C38.5495 156.231 40.0664 155.667 40.0052 155.257C39.9969 155.219 39.9774 155.184 39.9493 155.156Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M190.335 80.3874L188.736 80.626L196.292 131.236L197.89 130.997L190.335 80.3874Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M182.324 90.5693L180.459 90.8477L186.464 131.069L188.328 130.791L182.324 90.5693Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M184.627 111.465C188.893 110.828 191.835 106.853 191.198 102.587C190.561 98.3209 186.587 95.3788 182.32 96.0157C178.054 96.6526 175.112 100.627 175.749 104.894C176.386 109.16 180.361 112.102 184.627 111.465Z",
    fill: "#7A7A7A",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M184.069 107.736C186.276 107.407 187.798 105.351 187.468 103.144C187.139 100.938 185.083 99.4159 182.876 99.7453C180.67 100.075 179.148 102.131 179.477 104.337C179.807 106.544 181.863 108.066 184.069 107.736Z",
    fill: "#7A7A7A",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M183.632 104.806C184.22 104.718 184.626 104.17 184.538 103.581C184.45 102.993 183.902 102.587 183.314 102.675C182.725 102.763 182.319 103.311 182.407 103.899C182.495 104.488 183.043 104.894 183.632 104.806Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M187.332 129.578C191.598 128.941 194.54 124.967 193.903 120.7C193.266 116.434 189.292 113.492 185.025 114.129C180.759 114.766 177.817 118.741 178.454 123.007C179.091 127.273 183.066 130.215 187.332 129.578Z",
    fill: "#7A7A7A",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M186.774 125.85C188.981 125.52 190.503 123.464 190.173 121.258C189.844 119.051 187.788 117.529 185.581 117.859C183.375 118.188 181.853 120.244 182.182 122.451C182.512 124.657 184.568 126.179 186.774 125.85Z",
    fill: "#7A7A7A",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M186.337 122.919C186.925 122.831 187.331 122.283 187.243 121.695C187.155 121.106 186.607 120.7 186.019 120.788C185.43 120.876 185.024 121.424 185.112 122.013C185.2 122.601 185.748 123.007 186.337 122.919Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M197.573 128.867L179.727 131.531L180.045 133.662L197.891 130.998L197.573 128.867Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M132.787 106.929L132.379 108.716C132.379 108.716 123.97 113.588 120.429 116.57C116.888 119.552 116.848 121.764 117.9 123.448C118.951 125.131 128.526 138.777 128.526 138.777L128.873 139.46L128.555 140.978C128.555 140.978 125.336 143.237 124.44 143.801C123.544 144.365 122.808 144.78 123.524 145.471C124.24 146.162 127.049 145.68 127.921 145.359C128.794 145.038 130.547 144.474 131.518 144.392C132.489 144.309 134.39 144.331 133.936 142.928C133.481 141.525 132.827 140.027 132.609 139.385C132.39 138.742 129.417 132.381 128.77 130.087C128.122 127.792 127.421 124.57 126.394 123.44C125.368 122.311 124.685 121.621 124.685 121.621C124.685 121.621 127.947 120.635 130.78 119.73C133.683 118.829 136.507 117.69 139.222 116.324C139.222 116.324 143.719 113.997 146.39 113.413C149.062 112.829 151.199 111.53 151.719 109.674C152.24 107.818 151.318 104.522 149.251 102.992C147.185 101.463 146.942 101.496 146.942 101.496C144.955 103.054 142.649 104.152 140.187 104.713C136.265 105.544 133.571 105.156 133.571 105.156L132.787 106.929Z",
    fill: "#FF4A01",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M131.513 144.4C132.481 144.318 134.385 144.339 133.93 142.936C133.476 141.534 132.822 140.036 132.603 139.393C132.534 139.185 132.18 138.383 131.702 137.314C129.951 138.022 128.799 138.188 128.119 138.194L128.528 138.776L128.875 139.459L128.557 140.977C128.557 140.977 125.338 143.236 124.441 143.8C123.545 144.364 122.809 144.779 123.525 145.47C124.241 146.161 127.05 145.679 127.923 145.358C128.795 145.037 130.542 144.482 131.513 144.4Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M132.7 139.659L130.918 140.013L130.064 139.22C129.495 138.692 128.875 139.46 128.875 139.46L128.557 140.978C128.557 140.978 125.338 143.237 124.442 143.801C123.545 144.365 122.809 144.779 123.525 145.47C124.241 146.161 127.05 145.679 127.923 145.359C128.795 145.038 130.549 144.474 131.52 144.391C132.491 144.309 134.392 144.33 133.937 142.928C133.531 141.7 132.976 140.392 132.7 139.659Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M136.232 109.657L139.934 111.689",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M125.913 93.9124C125.913 93.9124 122.636 92.1905 120.79 91.2107C119.663 90.6069 118.594 89.9005 117.597 89.1005L118.333 85.2166L114.319 86.0364C114.319 86.0364 113.583 89.0271 114.329 89.5747L116.405 91.1111C116.405 91.1111 122.233 96.003 123.705 96.965C125.178 97.927 127.788 97.6108 127.788 97.6108L126.207 93.9311L125.913 93.9124Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M124.938 83.942C124.938 83.942 122.791 84.7527 122.61 86.0077C122.43 87.2627 124.384 91.3224 125.113 92.5016C125.48 93.0601 125.794 93.6512 126.052 94.2676C126.052 94.2676 126.291 97.1128 127.305 98.5545C128.318 99.9962 131.389 100.031 131.389 100.031L132.814 101.844L132.78 106.938C132.78 106.938 137.699 107.86 141.704 106.341C144.079 105.462 146.037 103.722 147.19 101.468L143.463 99.0804C143.463 99.0804 142.34 92.3805 141.684 89.2298C141.029 86.079 140.41 83.157 138.905 82.1019C137.399 81.0468 133.509 82.1096 133.14 82.1047C132.772 82.0998 131.728 81.2726 131.164 80.3765C130.6 79.4804 129.423 77.3252 129.423 77.3252C129.423 77.3252 128.145 77.8836 128.051 78.8181C127.956 79.7526 127.183 81.2159 126.501 81.993C125.819 82.7701 124.938 83.942 124.938 83.942Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M129.15 79.5717C129.15 79.5717 129.495 80.4025 128.866 82.1167C128.606 82.9048 128.278 83.6683 127.883 84.3982L126.379 82.7166C126.379 82.7166 128.844 79.985 129.15 79.5717Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M142.048 91.1497C141.413 91.5468 139.665 92.4094 137.92 91.2024C135.73 89.6884 134.747 84.7458 134.577 83.6058C134.452 82.7694 134.393 82.1546 134.372 81.8854C134.068 81.9308 133.805 81.9919 133.596 82.0313C133.718 83.2901 134.297 89.3006 134.324 90.9413C134.353 92.7777 132.268 94.0066 130.458 93.7868C128.647 93.567 127.447 92.5207 127.152 90.5416C126.856 88.5625 126.752 82.9359 126.752 82.9359L126.109 83.1544C126.109 83.1544 126.171 90.1353 125.965 91.6365C125.879 92.3927 125.857 93.1547 125.899 93.9146C126.01 94.1458 126.052 94.2621 126.052 94.2621C126.052 94.2621 126.291 97.1073 127.304 98.5491C128.318 99.9908 131.389 100.025 131.389 100.025L131.671 100.383C131.981 100.637 133.064 101.071 136.321 100.209C139.899 99.2612 142.218 97.5044 143.022 96.5811C142.746 94.9884 142.373 92.9092 142.048 91.1497Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M135.596 100.187C135.596 100.187 136.363 100.546 138.743 100.547L135.596 100.187Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M135.596 100.187C135.596 100.187 136.363 100.546 138.743 100.547",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M134.671 98.7777C134.671 98.7777 137.27 99.4599 139.686 97.3128",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M127.329 69.5419C127.329 69.5419 128.37 67.4805 130.475 68.0321C132.581 68.5837 135.91 74.0284 135.984 76.5905C136.059 79.1526 133.183 80.0041 131.227 79.6317C129.27 79.2594 129.251 76.2452 128.681 74.4921C128.112 72.7391 127.329 69.5419 127.329 69.5419Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M135.8 82.4259C135.8 82.4259 138.273 80.8475 140.41 82.4292C141.674 83.3539 142.759 84.5001 143.614 85.8122L149.412 91.3785C149.412 91.3785 149.812 87.0709 149.372 85.7885C148.933 84.5062 147.429 83.4401 147.1 82.8765C146.77 82.313 147.073 79.8144 147.073 79.8144C147.073 79.8144 150.92 79.3026 151.099 79.276C151.277 79.2493 152.053 80.7265 152.092 81.8235C152.13 82.9206 151.233 83.8579 151.233 83.8579C151.233 83.8579 152.705 89.2176 153.126 92.8935C153.547 96.5694 151.751 96.9274 149.816 96.1324C146.229 94.6666 144.316 92.575 142.827 91.6344C142.043 91.1586 141.304 90.6117 140.62 90.0006",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M135.8 82.4259C135.8 82.4259 138.273 80.8475 140.41 82.4292C141.674 83.3539 142.759 84.5001 143.614 85.8122L149.412 91.3785C149.412 91.3785 149.812 87.0709 149.372 85.7885C148.933 84.5062 147.429 83.4401 147.1 82.8765C146.77 82.313 147.073 79.8144 147.073 79.8144C147.073 79.8144 150.92 79.3026 151.099 79.276C151.277 79.2493 152.053 80.7265 152.092 81.8235C152.13 82.9206 151.233 83.8579 151.233 83.8579C151.233 83.8579 152.705 89.2176 153.126 92.8935C153.547 96.5694 151.751 96.9274 149.816 96.1324C146.229 94.6666 144.316 92.575 142.827 91.6344C142.043 91.1586 141.304 90.6117 140.62 90.0006",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M141.109 89.5603L140.139 90.8705",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M130.981 85.7975L133.566 83.8185",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M126.666 83.1934C126.666 83.1934 127.955 84.0738 128.201 86.0902",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M148.178 105.595C147.057 105.544 145.554 105.676 144.371 106.487C142.203 107.976 139.223 113.08 138.778 114.62C138.332 116.16 139.502 118.251 139.964 118.917C140.425 119.583 147.573 130.035 149.008 131.855C150.017 133.144 150.824 134.99 151.199 135.95C151.077 136.043 150.975 136.16 150.899 136.294L151.146 138.771C151.146 138.771 150.612 140.138 149.614 140.84C148.616 141.542 148.125 142.778 149.199 142.985C150.273 143.192 153.743 142.614 154.536 142.251C155.328 141.888 156.364 141.733 156.257 141.014C156.15 140.295 155.764 137.713 155.39 136.849C155.016 135.984 154.723 136.031 154.723 136.031L154.457 136.071C154.189 135.021 153.087 130.739 152.33 127.802C151.457 124.439 149.68 121.145 148.245 119.336C147.367 118.233 146.394 117.209 145.337 116.277C145.337 116.277 144.741 115.935 145.811 115.348C146.881 114.761 151.213 112.518 151.773 110.101C152.274 107.987 151.577 106.803 151.397 106.541",
    fill: "#FF4A01"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M148.178 105.595C147.057 105.544 145.554 105.676 144.371 106.487C142.203 107.976 139.223 113.08 138.778 114.62C138.332 116.16 139.502 118.251 139.964 118.917C140.425 119.583 147.573 130.035 149.008 131.855C150.017 133.144 150.824 134.99 151.199 135.95C151.077 136.043 150.975 136.16 150.899 136.294L151.146 138.771C151.146 138.771 150.612 140.138 149.614 140.84C148.616 141.542 148.125 142.778 149.199 142.985C150.273 143.192 153.743 142.614 154.536 142.251C155.328 141.888 156.364 141.733 156.257 141.014C156.15 140.295 155.764 137.713 155.39 136.849C155.016 135.984 154.723 136.031 154.723 136.031L154.457 136.071C154.189 135.021 153.087 130.739 152.33 127.802C151.457 124.439 149.68 121.145 148.245 119.336C147.367 118.233 146.394 117.209 145.337 116.277C145.337 116.277 144.741 115.935 145.811 115.348C146.881 114.761 151.213 112.518 151.773 110.101C152.274 107.987 151.577 106.803 151.397 106.541",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M154.553 142.248C155.356 141.883 156.381 141.73 156.274 141.011C156.167 140.292 155.781 137.711 155.407 136.846C155.033 135.981 154.74 136.028 154.74 136.028L154.474 136.068C154.388 135.729 154.214 135.053 153.993 134.195C152.939 134.563 151.831 134.755 150.715 134.764C150.921 135.217 151.092 135.63 151.216 135.947C151.094 136.04 150.992 136.157 150.916 136.291L151.163 138.768C151.163 138.768 150.629 140.135 149.631 140.837C148.633 141.539 148.142 142.775 149.216 142.982C150.29 143.189 153.749 142.613 154.553 142.248Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M154.554 142.249C155.357 141.884 156.383 141.731 156.275 141.011C156.168 140.292 155.783 137.711 155.409 136.847C155.034 135.982 154.742 136.028 154.742 136.028L153.964 136.145C153.964 136.145 152.92 135.317 152.561 135.371C152.096 135.519 151.647 135.712 151.22 135.947C151.098 136.041 150.996 136.158 150.92 136.291L151.167 138.768C151.167 138.768 150.633 140.135 149.635 140.837C148.637 141.539 148.146 142.775 149.22 142.982C150.294 143.19 153.751 142.614 154.554 142.249Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M103.885 92.4898C105.692 92.2201 106.845 89.9145 106.461 87.3401C106.076 84.7656 104.3 82.8972 102.494 83.1669C100.687 83.4366 99.5342 85.7423 99.9186 88.3167C100.303 90.8912 102.079 92.7595 103.885 92.4898Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M104.438 92.4068C106.245 92.1371 107.398 89.8315 107.013 87.257C106.629 84.6826 104.853 82.8142 103.046 83.0839C101.24 83.3536 100.087 85.6593 100.471 88.2337C100.856 90.8082 102.632 92.6765 104.438 92.4068Z",
    fill: "#7A7A7A",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M104.398 87.6482C104.475 88.1623 104.244 88.6242 103.882 88.6783C103.52 88.7324 103.167 88.3575 103.09 87.8434C103.014 87.3293 103.244 86.8674 103.604 86.8137C103.963 86.76 104.321 87.1314 104.398 87.6482Z",
    fill: "#7A7A7A",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M106.644 94.1663C109.244 93.7782 110.903 90.4619 110.35 86.7591C109.797 83.0563 107.242 80.3692 104.642 80.7573C102.043 81.1454 100.384 84.4617 100.936 88.1645C101.489 91.8672 104.045 94.5543 106.644 94.1663Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M107.443 94.0471C110.042 93.659 111.702 90.3428 111.149 86.64C110.596 82.9372 108.041 80.2501 105.441 80.6381C102.842 81.0262 101.183 84.3425 101.735 88.0453C102.288 91.7481 104.843 94.4352 107.443 94.0471Z",
    fill: "#7A7A7A",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M162.356 79.461L140.746 82.6873C140.027 81.9777 138.967 81.8636 139.255 81.8207L162.189 78.3968C162.331 78.3757 162.475 78.4116 162.589 78.4966C162.704 78.5815 162.781 78.7087 162.802 78.85C162.823 78.9913 162.787 79.1351 162.702 79.25C162.617 79.3648 162.49 79.4411 162.348 79.4622L162.356 79.461Z",
    fill: "#263238"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M124.498 84.0756C124.67 84.0222 124.848 83.991 125.029 83.9827C124.955 83.9597 124.877 83.9537 124.8 83.9651L105.992 86.773C105.85 86.7941 105.723 86.8705 105.638 86.9853C105.553 87.1001 105.517 87.244 105.539 87.3853C105.56 87.5266 105.636 87.6537 105.751 87.7387C105.866 87.8237 106.009 87.8596 106.151 87.8385L122.881 85.3407C123.264 84.7504 123.833 84.305 124.498 84.0756Z",
    fill: "#263238"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M165.246 85.4182C167.845 85.0301 169.504 81.7138 168.951 78.0111C168.399 74.3083 165.843 71.6212 163.244 72.0092C160.644 72.3973 158.985 75.7136 159.538 79.4164C160.091 83.1192 162.646 85.8063 165.246 85.4182Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M166.045 85.2991C168.644 84.911 170.303 81.5947 169.75 77.8919C169.198 74.1891 166.642 71.502 164.043 71.8901C161.443 72.2782 159.784 75.5945 160.337 79.2973C160.89 83 163.445 85.6872 166.045 85.2991Z",
    fill: "#7A7A7A",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M167.014 83.065C168.821 82.7953 169.974 80.4897 169.589 77.9153C169.205 75.3408 167.429 73.4724 165.623 73.7421C163.816 74.0118 162.663 76.3175 163.047 78.8919C163.432 81.4664 165.208 83.3347 167.014 83.065Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M167.567 82.983C169.374 82.7133 170.527 80.4077 170.142 77.8332C169.758 75.2588 167.982 73.3904 166.175 73.6601C164.369 73.9298 163.216 76.2354 163.6 78.8099C163.985 81.3843 165.761 83.2527 167.567 82.983Z",
    fill: "#7A7A7A",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M167.527 78.2234C167.604 78.7375 167.373 79.1994 167.011 79.2535C166.649 79.3076 166.296 78.9327 166.219 78.4186C166.143 77.9045 166.373 77.4426 166.733 77.3889C167.092 77.3352 167.45 77.7066 167.527 78.2234Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M116.231 84.0842C116.231 84.0842 113.656 85.0732 113.626 85.2901C113.62 85.481 113.658 85.6706 113.736 85.8447C113.815 86.0189 113.931 86.173 114.078 86.2955C114.413 86.5177 117.377 85.7022 117.626 85.5643C117.875 85.4264 117.629 84.6924 117.533 84.2683C117.437 83.8443 116.231 84.0842 116.231 84.0842Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M117.582 89.1023C117.582 89.1023 118.85 85.7052 118.796 85.3456C118.743 84.986 116.726 84.2442 116.536 83.9049C116.347 83.5656 115.913 83.998 116.208 84.6238C116.364 84.9741 116.582 85.2938 116.85 85.5682L117.195 85.8516C117.195 85.8516 115.632 87.294 115.296 88.1828C114.96 89.0716 116.697 89.2481 116.697 89.2481",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M117.582 89.1023C117.582 89.1023 118.85 85.7052 118.796 85.3456C118.743 84.986 116.726 84.2442 116.536 83.9049C116.347 83.5656 115.913 83.998 116.208 84.6238C116.364 84.9741 116.582 85.2938 116.85 85.5682L117.195 85.8516C117.195 85.8516 115.632 87.294 115.296 88.1828C114.96 89.0716 116.697 89.2481 116.697 89.2481",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M147.812 79.0288C147.812 79.0288 150.921 78.5647 151.19 78.8948L151.457 79.2226C151.457 79.2226 151.616 80.288 151.361 80.4024C151.106 80.5167 148.705 80.9813 147.992 80.9652C147.279 80.9492 147.511 79.5666 147.457 79.207C147.404 78.8474 147.812 79.0288 147.812 79.0288Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M149.183 82.2197C148.827 81.7765 148.445 81.3552 148.038 80.9581C147.763 80.7542 146.963 80.3208 146.963 80.3208C146.963 80.3208 148.348 79.7465 148.285 79.3283C148.223 78.9101 147.512 79.0734 147.25 79.3603C146.988 79.6473 145.897 79.7448 145.968 80.2243C146.04 80.7037 145.979 81.9408 146.411 82.3666C146.842 82.7924 148.459 83.7763 148.459 83.7763",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M149.183 82.2197C148.827 81.7765 148.445 81.3552 148.038 80.9581C147.763 80.7542 146.963 80.3208 146.963 80.3208C146.963 80.3208 148.348 79.7465 148.285 79.3283C148.223 78.9101 147.512 79.0734 147.25 79.3603C146.988 79.6473 145.897 79.7448 145.968 80.2243C146.04 80.7037 145.979 81.9408 146.411 82.3666C146.842 82.7924 148.459 83.7763 148.459 83.7763",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M119.314 71.2318C118.889 72.3568 118.832 73.5875 119.15 74.7472C119.859 77.0323 120.386 78.9196 120.386 78.9196C120.459 79.7685 120.729 80.5887 121.174 81.3154C121.885 82.4345 123.987 84.1467 124.707 84.0393C125.426 83.9319 126.499 83.2788 127.536 82.4515C128.572 81.6241 129.328 79.6677 129.266 79.2495L129.096 78.1095C129.096 78.1095 130.058 77.168 130.062 76.3723C130.042 75.7427 129.97 75.1159 129.845 74.4985C129.845 74.4985 129.758 71.8756 128.047 69.8654C126.337 67.8552 123.282 68.2431 121.19 69.111C120.29 69.485 119.662 70.2922 119.314 71.2318Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M121.118 68.5573C120.587 68.7748 120.132 69.1449 119.812 69.6208C119.491 70.0966 119.319 70.6569 119.317 71.2307C119.298 71.5767 119.103 71.8997 119.043 72.2437L119.086 72.2373C119.086 72.2373 119.099 71.9276 119.601 72.0379C120.102 72.1482 120.359 72.5972 121.884 72.1244C123.41 71.6517 124.755 70.4107 125.358 70.7481C125.961 71.0856 126.022 72.7348 126.113 73.7642C126.204 74.7935 127.618 74.3972 127.618 74.3972C127.618 74.3972 128.064 75.7412 128.498 75.3687C128.933 74.9961 128.868 73.7205 129.841 74.4929C129.841 74.4929 130.032 71.0333 128.321 69.0204C126.61 67.0076 123.21 67.6895 121.118 68.5573Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M125.287 77.2344C125.329 77.514 125.214 77.7627 125.033 77.7898C124.851 77.8168 124.668 77.6127 124.627 77.333C124.585 77.0533 124.7 76.8019 124.881 76.7749C125.062 76.7479 125.246 76.9547 125.287 77.2344Z",
    fill: "#263238"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M121.809 77.7539C121.851 78.0336 121.735 78.2823 121.554 78.3093C121.373 78.3363 121.19 78.1322 121.148 77.8525C121.106 77.5728 121.221 77.3215 121.403 77.2944C121.584 77.2674 121.767 77.4742 121.809 77.7539Z",
    fill: "#263238"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M122.514 77.5586C122.58 78.0214 122.609 78.4888 122.6 78.9563C122.569 79.5735 122.015 79.964 122.512 80.0123C122.858 80.038 123.206 80.0272 123.55 79.9798",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M124.371 81.4098C124.423 81.5191 124.431 81.6442 124.393 81.7591C124.355 81.8739 124.273 81.9695 124.166 82.0259C123.959 82.095 123.72 81.9346 123.628 81.6651C123.576 81.5559 123.568 81.4307 123.606 81.3159C123.644 81.2011 123.726 81.1055 123.833 81.0491C124.04 80.98 124.279 81.1404 124.371 81.4098Z",
    fill: "#263238"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M123.467 76.5527C123.467 76.5527 124.628 75.704 125.641 75.9204",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M122.082 77.1324C121.639 76.8806 121.131 76.7668 120.623 76.8057",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M116.65 72.9115C118.006 71.6388 119.042 72.2439 119.042 72.2439C119.042 72.2439 116.51 73.5286 116.771 75.2733",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M118.842 77.0395C118.842 77.0395 117.153 76.1071 117.205 76.8944C117.244 77.4823 118.842 77.0395 118.842 77.0395Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M118.978 77.9502C118.978 77.9502 117.549 78.2125 117.464 78.9577C117.379 79.7028 118.978 77.9502 118.978 77.9502Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1176 102.562C66.1176 102.562 66.197 107.362 66.4451 110.228C66.6932 113.093 68.5265 124.169 68.5154 124.716C68.5044 125.262 69.1842 127.973 69.1842 127.973C69.1842 127.973 67.4279 133.227 67.5617 136.567C67.6955 139.908 68.1303 150.098 68.1303 150.098L71.0468 149.57C71.0468 149.57 72.8383 139.682 74.0389 136.779C75.2394 133.877 76.709 127.305 76.9765 125.449C77.2439 123.592 79.1631 113.958 79.1631 113.958C79.1631 113.958 86.2559 121.34 87.6987 122.486C89.1415 123.632 91.2384 126.132 91.2384 126.132C91.2384 126.132 91.6941 129.787 93.1064 132.571C94.5188 135.356 97.2044 138.133 98.7387 141.716C99.2192 142.837 100.02 145.427 100.02 145.427L103.137 144.417C103.137 144.417 102.626 142.636 101.883 139.068C99.9452 129.734 96.7338 121.592 96.3612 120.921C95.9887 120.249 91.9813 111.045 89.6928 108.483C87.4043 105.922 86.0867 104.393 86.0867 104.393L83.5775 100.955C80.4318 101.863 77.2348 102.582 74.0035 103.109C69.3873 103.798 66.1176 102.562 66.1176 102.562Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6916 108.484C87.4027 105.92 86.0855 104.393 86.0855 104.393L83.5763 100.955C80.4306 101.863 77.2336 102.582 74.0023 103.109C69.3861 103.798 66.1164 102.563 66.1164 102.563C66.1164 102.563 66.1958 107.362 66.4439 110.228C66.6337 112.43 67.7563 119.457 68.2641 122.858C71.3355 123.035 74.4162 122.96 77.4751 122.632C78.1296 119.136 79.1748 113.953 79.1748 113.953C79.1748 113.953 83.5237 118.478 86.1021 120.993C89.1129 120.156 92.0228 118.991 94.7792 117.519C93.3025 114.431 91.1466 110.113 89.6916 108.484Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M103.4 141.926C103.4 141.926 101.648 141.733 101.741 142.357L101.744 142.375C101.771 142.573 101.755 142.775 101.697 142.966C101.639 143.158 101.54 143.334 101.407 143.484C101.273 143.633 101.11 143.752 100.926 143.831C100.743 143.911 100.544 143.95 100.344 143.946C99.7988 143.94 99.3328 143.974 99.3559 144.129C99.4092 144.486 99.2889 147.894 100.25 148.295C101.211 148.696 102.56 147.95 103.438 148.363C104.317 148.777 106.157 148.954 107.654 148.641C109.151 148.327 110.925 148.063 109.914 146.76C108.902 145.456 106.617 145.345 105.585 144.503C104.552 143.661 103.4 141.926 103.4 141.926Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2603 147.359C71.2603 147.359 70.2011 146.339 69.1115 146.956C68.8074 147.112 68.5567 147.355 68.3914 147.654C68.2261 147.954 68.1536 148.295 68.1832 148.636C68.1832 148.636 67.8832 151.496 67.4033 151.93C66.9235 152.364 66.4691 154.793 67.3347 155.118C68.2002 155.444 70.8635 155.043 71.8629 154.442C72.8624 153.841 72.5836 151.974 72.4377 150.996C72.2917 150.018 72.4523 149.27 72.2582 148.572C72.222 148.388 72.1181 148.224 71.9668 148.112C71.8156 148.001 71.6281 147.95 71.4413 147.97L71.2603 147.359Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7643 73.3992C71.7643 73.3992 66.1453 76.6371 63.8996 78.1378C61.6538 79.6385 60.6276 82.395 60.8785 84.0758C61.1294 85.7565 65.3434 96.9836 65.547 97.4352C65.7505 97.8868 66.0359 103.465 66.0359 103.465C66.0359 103.465 69.2909 105.514 75.4229 104.326C81.5549 103.138 83.7244 102.057 84.2113 101.652C84.6982 101.248 83.8332 97.7332 83.7166 96.5144C83.5999 95.2955 85.8734 87.0674 85.8734 87.0674C85.8734 87.0674 88.0163 89.4924 88.844 89.9842C89.3018 90.2488 89.7182 90.5793 90.0797 90.9652C90.0797 90.9652 91.7158 94.6285 93.2767 95.836C94.8375 97.0435 97.576 101.087 97.6821 101.414C97.7881 101.741 97.5055 102.53 97.5365 102.737C97.5675 102.945 96.7683 104.486 97.0989 104.859C97.4296 105.231 97.2795 106.068 97.7214 106.274C98.0292 106.413 98.3476 106.527 98.6735 106.614C99.0445 106.915 99.5031 107.087 99.9804 107.105C100.168 107.1 100.348 107.032 100.491 106.911C100.635 106.791 100.734 106.626 100.772 106.442C100.772 106.442 102.358 105.117 102.273 104.092C102.099 102.479 101.514 100.938 100.575 99.6152C99.3471 97.8107 96.9933 91.2374 96.0061 89.6774C95.019 88.1174 93.1454 86.1288 93.1454 86.1288L88.065 79.3308C88.065 79.3308 85.9161 75.8802 83.7708 74.8989C81.6256 73.9175 78.2089 73.4664 76.7398 73.2745C75.2706 73.0827 71.7643 73.3992 71.7643 73.3992Z",
    fill: "#FF4A01",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5329 72.9651C70.6554 74.0234 70.8574 75.071 71.1369 76.099C71.5497 77.4779 73.0697 78.4845 75.1534 78.6527C77.2371 78.8209 78.2208 77.1654 78.5622 76.224C78.9037 75.2826 78.5938 73.6814 78.5938 73.6814C78.071 74.2151 77.4068 74.5886 76.6792 74.758C75.9515 74.9274 75.1907 74.8857 74.4859 74.6378C73.13 74.1752 71.809 73.6162 70.5329 72.9651Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3547 74.5331C76.449 74.9454 75.4171 74.983 74.4839 74.6377C73.1993 74.1937 71.9441 73.6689 70.7257 73.0666L70.5517 73.1416C70.6733 74.1403 70.8681 75.1287 71.1348 76.0989C71.2053 76.3286 71.3058 76.548 71.4337 76.7514C72.1632 77.0522 72.9496 77.1904 73.738 77.1562C77.0743 76.9958 78.5387 74.9309 78.5387 74.9309L77.3547 74.5331Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7402 76.8545C69.7402 76.8545 71.071 79.3299 72.5612 80.1367",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M79.678 76.812C79.627 77.9486 79.451 79.0762 79.1534 80.1743",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9642 83.9587C88.1841 83.5326 88.3628 83.0865 88.4978 82.6264",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1126 82.5507C86.6054 84.6252 85.8799 87.0617 85.8799 87.0617C86.4859 86.3418 87.0353 85.576 87.5231 84.7714",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M87.507 80.5805C87.4652 80.9026 87.3934 81.2972 87.3002 81.7305",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3566 86.9119C87.3566 86.9119 89.044 85.3556 89.8214 84.1422",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0644 96.6032C98.029 97.3634 96.9519 98.0651 95.8382 98.705C96.5108 99.5714 97.1276 100.48 97.6847 101.425C97.8014 101.75 97.5081 102.54 97.5392 102.748C97.5702 102.956 96.7709 104.497 97.1016 104.869C97.4322 105.242 97.2821 106.079 97.7241 106.285C98.0308 106.42 98.3477 106.53 98.6719 106.614C99.0428 106.915 99.5014 107.088 99.9787 107.106C100.166 107.1 100.346 107.032 100.49 106.912C100.633 106.791 100.732 106.626 100.77 106.443C100.77 106.443 102.356 105.117 102.271 104.092C102.097 102.479 101.513 100.938 100.573 99.6156C99.9931 98.652 99.4886 97.6448 99.0644 96.6032Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M66.724 89.7172C66.724 89.7172 68.0058 87.7422 68.6894 86.3385",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9978 90.1585C67.9674 89.7305 68.8115 89.0618 69.4499 88.2158",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5234 100.304C66.5234 100.304 68.5222 101.307 70.6112 101.055",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0393 98.992C79.7114 100.115 78.2148 101.023 76.6045 101.68",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7894 97.192C82.4907 97.5818 82.162 97.9477 81.8064 98.2863",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6246 101.877C73.7778 101.553 75.8773 100.939 77.8657 100.052",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8274 67.0214C78.8274 67.0214 79.2737 66.8186 79.4085 67.7216C79.4635 68.3804 79.3768 69.0433 79.1541 69.6657L78.8274 67.0214Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7827 69.2129C68.7827 69.2129 67.4425 68.3891 67.4872 69.9835C67.5319 71.578 68.9535 72.0711 69.2039 72.0337L69.4542 71.9963C69.4542 71.9963 69.8133 73.5439 70.9552 74.3346C72.0971 75.1254 74.5615 76.1653 75.7161 76.1835C76.8706 76.2018 78.0148 75.7124 78.5408 74.9313C79.0668 74.1502 79.5342 72.1552 79.3938 71.215C79.2534 70.2747 78.668 65.496 78.5646 64.8034C78.4612 64.1109 78.5378 62.0517 75.7644 61.0579C72.991 60.0642 68.783 62.3562 68.0391 63.8124C67.2953 65.2686 68.7827 69.2129 68.7827 69.2129Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0262 71.022C74.033 71.181 74.0984 71.3319 74.2099 71.4455C74.3214 71.5591 74.4711 71.6274 74.63 71.6371C75.2134 71.678 76.5571 71.668 76.8674 71.1751C76.9557 71.0186 77.0053 70.8432 77.0121 70.6636C77.0189 70.4841 76.9828 70.3054 76.9066 70.1427",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M76.806 72.4344C76.806 72.4344 74.7272 72.6822 74.5516 73.2203C74.376 73.7585 76.7558 73.8307 77.4428 72.8513C77.8675 72.2487 76.806 72.4344 76.806 72.4344Z",
    fill: "#263238"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5583 69.3355C73.6108 69.6871 73.5091 69.9909 73.3359 70.0168C73.1628 70.0426 72.9768 69.7817 72.9243 69.4301C72.8718 69.0785 72.9713 68.7778 73.1471 68.7515C73.3229 68.7253 73.5062 68.9865 73.5583 69.3355Z",
    fill: "#263238"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2931 68.6145C77.3455 68.9661 77.2439 69.2699 77.0707 69.2958C76.8976 69.3216 76.7116 69.0608 76.6591 68.7092C76.6066 68.3575 76.7056 68.0541 76.8814 68.0279C77.0572 68.0016 77.241 68.2656 77.2931 68.6145Z",
    fill: "#263238"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5049 68.0136C71.7767 67.8256 72.0964 67.7189 72.4267 67.7057C72.7569 67.6926 73.0841 67.7736 73.37 67.9394",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2505 67.338C76.4286 67.1432 76.6489 66.9917 76.8946 66.8951C77.1402 66.7985 77.4046 66.7593 77.6677 66.7806",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1759 91.8333C79.1759 91.8333 80.6152 91.8254 80.8772 92.6685C81.1393 93.5117 80.3287 94.4659 79.5322 95.1322C78.7358 95.7984 75.7861 94.3898 75.2137 93.3098C74.6413 92.2298 79.1759 91.8333 79.1759 91.8333Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8426 79.3255C62.8426 79.3255 60.5995 80.8258 59.7008 83.0867C58.8021 85.3476 58.3602 92.4744 58.2517 94.9577C58.1432 97.441 58.5183 100.884 59.0097 100.947C59.501 101.01 67.137 98.8431 69.3893 98.3707C71.6415 97.8983 74.3388 97.0872 74.3388 97.0872C74.3388 97.0872 78.1117 97.5532 78.6188 97.2651C79.1258 96.977 79.7949 95.5129 79.7949 95.5129C79.7949 95.5129 81.074 94.4315 81.3293 93.8433C81.5846 93.2552 81.4656 92.9326 80.8372 93.3014C80.2178 93.7265 79.5056 93.9971 78.7602 94.0907C77.6948 94.2498 76.4332 93.2046 76.4332 93.2046L77.111 92.6922C77.111 92.6922 78.4068 92.6349 78.8557 92.4318C79.3046 92.2286 79.2381 91.3454 78.8298 91.3464C78.1302 91.3919 77.4334 91.4732 76.7422 91.59C76.2094 91.6695 75.1204 91.2875 74.5183 91.8512C73.9163 92.4149 72.7651 93.8965 72.7651 93.8965C72.7651 93.8965 69.2817 94.8958 68.3908 94.8927C67.4999 94.8895 66.2504 94.801 66.2504 94.801C66.2504 94.801 67.163 92.195 67.0915 91.3152C67.0201 90.4355 66.7837 89.7274 66.6276 87.7519",
    fill: "#FF4A01"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8426 79.3255C62.8426 79.3255 60.5995 80.8258 59.7008 83.0867C58.8021 85.3476 58.3602 92.4744 58.2517 94.9577C58.1432 97.441 58.5183 100.884 59.0097 100.947C59.501 101.01 67.137 98.8431 69.3893 98.3707C71.6415 97.8983 74.3388 97.0872 74.3388 97.0872C74.3388 97.0872 78.1117 97.5532 78.6188 97.2651C79.1258 96.977 79.7949 95.5129 79.7949 95.5129C79.7949 95.5129 81.074 94.4315 81.3293 93.8433C81.5846 93.2552 81.4656 92.9326 80.8372 93.3014C80.2178 93.7265 79.5056 93.9971 78.7602 94.0907C77.6948 94.2498 76.4332 93.2046 76.4332 93.2046L77.111 92.6922C77.111 92.6922 78.4068 92.6349 78.8557 92.4318C79.3046 92.2286 79.2381 91.3454 78.8298 91.3464C78.1302 91.3919 77.4334 91.4732 76.7422 91.59C76.2094 91.6695 75.1204 91.2875 74.5183 91.8512C73.9163 92.4149 72.7651 93.8965 72.7651 93.8965C72.7651 93.8965 69.2817 94.8958 68.3908 94.8927C67.4999 94.8895 66.2504 94.801 66.2504 94.801C66.2504 94.801 67.163 92.195 67.0915 91.3152C67.0201 90.4355 66.7837 89.7274 66.6276 87.7519",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1286 94.8684C66.1286 94.8684 63.9105 94.7666 62.4434 94.7705",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8361 93.301C80.2167 93.726 79.5046 93.9967 78.7592 94.0903C77.6937 94.2494 76.4321 93.2042 76.4321 93.2042L77.1099 92.6918C77.1099 92.6918 78.4057 92.6345 78.8546 92.4313C79.3035 92.2282 79.237 91.3449 78.8287 91.346C78.1292 91.3915 77.4324 91.4728 76.7411 91.5896C76.2084 91.6691 75.1193 91.2871 74.5173 91.8508C73.9152 92.4145 72.764 93.8961 72.764 93.8961C72.764 93.8961 69.2806 94.8954 68.3897 94.8923L68.237 94.8906C68.1558 96.1272 68.2441 97.3692 68.4994 98.582C68.8463 98.4975 69.149 98.4278 69.3894 98.3783C71.6492 97.902 74.3389 97.0948 74.3389 97.0948C74.3389 97.0948 78.1118 97.5608 78.6189 97.2727C79.1259 96.9846 79.7951 95.5205 79.7951 95.5205C79.7951 95.5205 81.0741 94.4391 81.3294 93.8509C81.5847 93.2628 81.4672 92.9317 80.8361 93.301Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M181.005 25.3644L180.774 23.8141L179.327 24.03L177.936 14.7071L177.645 14.7505L179.037 24.0734L177.889 24.2448L178.12 25.795C176.646 26.3381 175.392 27.3527 174.553 28.6813C173.714 30.0098 173.337 31.5782 173.48 33.143L187.573 31.0389C187.254 29.5028 186.438 28.1146 185.251 27.0889C184.063 26.0632 182.571 25.4571 181.005 25.3644Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M102.427 37.0948L102.196 35.5446L100.749 35.7605L99.3574 26.4376L99.0671 26.481L100.459 35.8039L99.3108 35.9752L99.5423 37.5255C98.0678 38.0686 96.8137 39.0831 95.9747 40.4117C95.1357 41.7403 94.7585 43.3086 94.9018 44.8734L108.995 42.7694C108.676 41.2333 107.86 39.845 106.673 38.8193C105.485 37.7936 103.993 37.1876 102.427 37.0948Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1106 48.1905L27.8792 46.6403L26.4328 46.8562L25.041 37.5333L24.7507 37.5767L26.1425 46.8996L24.9944 47.0709L25.2259 48.6212C23.7514 49.1643 22.4973 50.1789 21.6583 51.5074C20.8192 52.836 20.4421 54.4043 20.5854 55.9691L34.6789 53.8651C34.3597 52.329 33.5434 50.9407 32.3561 49.915C31.1689 48.8894 29.6769 48.2833 28.1106 48.1905Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_184_805",
    x: 130.334,
    y: 52.6172,
    width: 153.42,
    height: 129.484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.156863 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_805",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_184_805",
    x: 0.591797,
    y: 0.592773,
    width: 213.891,
    height: 185.787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.156863 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_805",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.725,
    height: 88.5814,
    fill: "white",
    transform: "translate(135.354 67.7041) rotate(2.70437)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_184_805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.108,
    height: 134.66,
    fill: "white",
    transform: "translate(5.09766 38.6748) rotate(-8.49105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentreHeroLeft);
export default __webpack_public_path__ + "static/media/centre-hero-left.6b3401f28f6ecdec2940687ed2916a1f.svg";
export { ForwardRef as ReactComponent };